import {getCookie} from "../../../utils/fun_cookie";
// Admin API legacy base (proxied by nginx to backend when available)
const API_URL = '/api/admin/'

export async function getServersAPI(){
    let response = await fetch(API_URL+'get_servers',{
        method:'GET',
        headers: {
            'Authorization': getCookie('key'),
            'Content-Type': 'application/json'
        }
    });
    const res = await response.json()
    if(res.status === 'OK')
        return res.res
    else
        console.log(res.message)
        return false
}

export async function updateServerAPI(id){
    let response = await fetch(API_URL+'update_server?id='+id,{
        method:'GET',
        headers: {
            'Authorization': getCookie('key'),
            'Content-Type': 'application/json'
        }
    });
    const res = await response.json()
    if(res.status === 'OK')
        return true
    else
        console.log(res.message)
    return false
}

export async function getClientsAPI(){
    let response = await fetch(API_URL+'get_clients',{
        method:'GET',
        headers: {
            'Authorization': getCookie('key'),
            'Content-Type': 'application/json'
        }
    });
    const res = await response.json()
    if(res.status === 'OK')
        return res.res
    else
        console.log(res.message)
    return false
}


export async function deleteConfigsAPI(ids){
    let response = await fetch(API_URL+'delete_configs?ids='+ids.join('-'),{
        method:'GET',
        headers: {
            'Authorization': getCookie('key'),
            'Content-Type': 'application/json'
        }
    });
    const res = await response.json()
    if(res.status === 'OK')
        return true
    else
        console.log(res.message)
    return false
}


export async function addBalanceAPI(telegram_id, comment, amount){
    let response = await fetch(API_URL+'add_balance?telegram_id='+telegram_id+'&comment='+comment+'&sum='+amount,{
        method:'GET',
        headers: {
            'Authorization': getCookie('key'),
            'Content-Type': 'application/json'
        }
    });
    const res = await response.json()
    if(res.status === 'OK')
        return true
    else
        console.log(res.message)
    return false
}


export async function getPaymentsAPI(){
    let response = await fetch(API_URL+'get_payments',{
        method:'GET',
        headers: {
            'Authorization': getCookie('key'),
            'Content-Type': 'application/json'
        }
    });
    const res = await response.json()
    if(res.status === 'OK')
        return res.res
    else
        console.log(res.message)
    return false
}